import React, { useState } from "react";
import Card, { CardContent, CardMedia } from "material-ui/Card";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import moment from "moment";
import Grade from "../graphics/Grade";
import styled from "styled-components";
import { useBeachCardDisplayInfo } from "./useBeachCardDisplayInfo";

const Container = styled(Card)`
  @media (orientation: portrait) {
    margin: 20px 10px;
    min-height: 260px;

    .cardMedia {
      height: 140px;
    }
  }
  @media (orientation: landscape) {
    height: 100%;
  }
  @media (min-height: 630px) and (orientation: portrait) {
    height: 280px !important;

    .cardMedia {
      height: 140px;
    }
  }
  @media (min-height: 660px) and (orientation: portrait) {
    height: 300px !important;

    .cardMedia {
      height: 160px;
    }
  }
  h3 {
    font-size: 12px;
    @media (min-width: 600px) {
      font-size: 14px;
    }
    @media (min-width: 960px) {
      font-size: 16px;
    }
  }
`;
const Content = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const Label = styled.div`
  text-transform: capitalize;

  span {
    font-weight: 600;
  }
`;

const BeachCard = ({
  onHoverIn = () => null,
  onHoverOut = () => null,
  onClick = () => null,
  beach,
  tab = 0
}) => {
  const [hovered, setHovered] = useState(false);
  const { label, grade, icon, dateGraded, image, header, subheader } =
    useBeachCardDisplayInfo({
      beach,
      tab
    });

  const onMouseEnter = () => {
    setHovered(true);
    onHoverIn();
  };

  const onMouseLeave = () => {
    setHovered(false);
    onHoverOut();
  };

  return (
    <Container
      className="resultsCard"
      onClick={onClick}
      elevation={hovered ? 3 : 0}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      <CardMedia className="cardMedia" image={image} title={beach.title} />
      <Content>
        <Typography color="primary" component="h2" variant="headline">
          {header}
        </Typography>
        <Typography color="primary" variant="subheading" gutterBottom={true}>
          {subheader}
        </Typography>
        <Grid container justify="space-between" spacing={8}>
          <Grid item xs={8}>
            <Label className="grade">
              {label} <span>{grade}</span>
            </Label>
            {dateGraded}
          </Grid>
          <Grid item xs={4} style={{ textAlign: "right" }}>
            <Grade grade={icon} />
          </Grid>
        </Grid>
      </Content>
    </Container>
  );
};

export default BeachCard;



// WEBPACK FOOTER //
// ./src/components/BeachCard/index.js